import { GameModeConfig, GameMode } from '../types/collection';
import artistCollection from '../assets/artistCollection.json';
import pokemonCollection from '../assets/pokemonCollection.json';

export const GAME_MODES: GameModeConfig[] = [
  {
    id: 'artist',
    label: 'Artist Collection',
    collection: artistCollection,
  },
  {
    id: 'pokemon',
    label: 'Pokemon Collection',
    collection: pokemonCollection,
  },
];

export const getGameModeConfig = (mode: GameMode): GameModeConfig | undefined => {
  return GAME_MODES.find(m => m.id === mode);
};

export const getCollectionByMode = (mode: GameMode) => {
  const config = getGameModeConfig(mode);
  return config ? config.collection : artistCollection;
};

